import { render } from "./JournalStudentStatuses.vue?vue&type=template&id=3e46c8e8"
import script from "./JournalStudentStatuses.vue?vue&type=script&lang=js"
export * from "./JournalStudentStatuses.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/krasp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/JournalStudentStatuses.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e46c8e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e46c8e8', __exports__)) {
    api.reload('3e46c8e8', __exports__)
  }
  
  module.hot.accept("./JournalStudentStatuses.vue?vue&type=template&id=3e46c8e8", () => {
    api.rerender('3e46c8e8', render)
  })

}


export default __exports__